// App UI: alert/flash close, etc. (eligibility modals use Flowbite: data-modal-* in markup)
let bound = false

export function initAppUi() {
  if (bound) return
  bound = true

  document.addEventListener("click", (e) => {
    const t = e.target
    if (!(t instanceof Element)) return

    if (t.matches?.("[data-action='dismiss-flash'], .app-flash__close")) {
      t.closest(".app-flash, [role='alert']")?.remove()
    }

    if (t.classList?.contains("btn-close") && t.closest(".alert")) {
      t.closest(".alert")?.remove()
    }
  })
}
